import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DeleteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Delete",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.11 9.46H24.8c.77.07 1.45-.51 1.52-1.28s-.51-1.45-1.28-1.52h-3.5V5.42c0-1.88-1.52-3.42-3.4-3.42h-4.38c-1.88 0-3.41 1.53-3.41 3.41v1.21H7.13c-.78 0-1.42.63-1.42 1.42s.63 1.42 1.42 1.42Zm6.02-4.05c0-.34.28-.62.62-.62h4.37c.34 0 .61.27.61.61v1.22h-5.59V5.41Zm10.03 21.18 1.18-14.24c0-.55-.45-.99-.99-.99H8.43c-.55 0-.99.45-.99.99L8.72 26.6c.16 1.92 1.77 3.4 3.7 3.4h7.04c1.93 0 3.54-1.48 3.7-3.4Zm-2.98-10.54-.47 8.4c-.06.51-.49.89-.99.89-.5-.06-.88-.49-.88-.99l.47-8.4c.01-.49.41-.89.91-.9h.06c.52.04.93.47.93.99h-.02Zm-7.51-.99c.51 0 .93.37.99.88l.42 8.43c0 .5-.37.93-.87.99h-.06c-.51 0-.94-.38-.99-.89l-.47-8.4v-.05c0-.52.4-.95.92-.99z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25 8H7c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1M13 24c-.55 0-1-.45-1-1V13c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1M19 24c-.55 0-1-.45-1-1V13c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20 8h-8c-.55 0-1-.45-1-1V5c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v2c0 .55-.45 1-1 1m-7-2h6V5c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1zM21 30H11c-2.76 0-5-2.24-5-5V11c0-.55.45-1 1-1s1 .45 1 1v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V11c0-.55.45-1 1-1s1 .45 1 1v14c0 2.76-2.24 5-5 5"
      })]
    })
  }));
};
DeleteIcon.displayName = 'DeleteIcon';